<template>
  <div class="order-detail">
    <van-nav-bar title="订单详情" left-arrow @click-left="goBack" />

    <div class="order-detail-status" v-if="+orderDetail.returnState === 0">
      <h4>
        <svg class="icon icon-time" aria-hidden="true">
          <use xlink:href="#icon-shijian"></use>
        </svg>
        您的退款申请已受理，等待景区确认
      </h4>
      <p>预计需1到3个工作日,确认后打款至您的账户,请耐心等待！</p>
    </div>

    <div class="order-detail-info">
      <h3>{{ orderDetail.ticketModelName }}</h3>
      <van-cell-group class="order-detail-cell-group">
        <van-cell title="游客姓名" :value="orderDetail.realName" />

        <van-cell title="可用日期" :value="formatDay(orderDetail.playDate)" />

        <van-cell title="订单类型" :value="getOrderType(orderDetail.flag)" />

        <van-cell title="门票单价" :value="`¥${orderDetail.ticketPrice}`" />

        <van-cell
          title="预约时段"
          v-if="orderDetail.startTimeStock && orderDetail.endTimeStock"
          :value="`${orderDetail.startTimeStock}-${orderDetail.endTimeStock}`"
        />

        <van-cell
          v-if="isRefund()"
          title="退票状态"
          :value="returnStatus(orderDetail)"
        />

        <van-cell
          title="可用金额"
          :value="
            `¥${orderDetail.paySum ||
              orderDetail.sellPrice * orderDetail.ticketCount}`
          "
        />
      </van-cell-group>
      <div class="form-action">
        <van-button
          class="form-btn"
          v-if="!isRefund()"
          round
          block
          type="info"
          native-type="submit"
          @click="refund"
        >
          退票
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from '@sdi/fish';
import { formatDay, checkStatus, returnStatus, getOrderType } from '@/utils';

export default {
  name: 'OrderDetail',
  components: {},
  data: () => ({
    orderDetail: {}
  }),
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData() {
      this.orderDetail = this.$store.getters.getOrderById(this.$route.query.id);
    },
    isRefund() {
      return this.$store.getters.isRefund(this.$route.query.id);
    },
    formatDay,
    checkStatus,
    returnStatus,
    getOrderType,
    refund() {
      if (this.orderDetail.groupFlag === 'T') {
        Dialog.confirm({
          className: 'order-detail-dialog',
          title: '退票确认',
          message: `当前是团队订单，可退金额 ${this.orderDetail.ticketPrice} 元，请确认是是否还继续退票，如对金额有疑问，可先咨询导游处理。`
        })
          .then(() => {
            this.$router.push({
              name: 'orderRefund',
              query: {
                id: this.$route.query.id
              }
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({
          name: 'orderRefund',
          query: {
            id: this.$route.query.id
          }
        });
      }
    },
    goBack() {
      this.$router.replace({
        name: 'orderList',
        query: {
          status: this.isRefund() ? 'done' : 'todo'
        }
      });
    }
  }
};
</script>

<style lang="less">
.orders {
  background-color: #f7f7f7;
  min-height: 100vh;
}
.order-detail-info {
  margin-top: 8px;
  background-color: #fff;
  min-height: calc(100vh - 54px);
  box-sizing: border-box;
  padding: 15px 10px;
  h3 {
    font-size: 15px;
    color: #333;
    margin: 0 0 12px;
    padding-left: 14px;
  }
}
.order-detail-status {
  background-color: #ffb83d;
  height: 75px;
  box-sizing: border-box;
  padding: 20px 0 20px 24px;
  line-height: 1;
  color: #fff;
  h4 {
    margin: 0;
    font-size: 15px;
  }
  p {
    font-size: 12px;
    padding-left: 20px;
  }
  .icon-time {
    width: 15px;
    height: 15px;
  }
}
.order-detail-cell-group {
  .van-cell::after {
    left: 0;
    right: 0;
  }
  .van-cell__title {
    width: 74px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: auto;
    color: #999999;
  }
  .van-cell__value {
    text-align: left;
    color: #333333;
  }
}
.order-detail-dialog.van-dialog {
  border-radius: 5px !important;
  width: 260px;
  .van-dialog__header {
    color: #333;
    font-size: 16px;
    font-weight: 700;
    padding-top: 22px;
  }
  .van-dialog__message {
    text-align: left;
    padding: 15px 15px;
  }
  .van-button--default,
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #7090ff;
  }
}
</style>
